import { createBrowserRouter } from 'react-router-dom';

import PrivateRoute from '@components/guards/PrivateRoute';
import Layout from '@components/layout/Layout';

import ContactList from './ContactList';
import Login from './login/Login';
import NotFound from './NotFound';

export const LOGIN_PATH = 'login';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <PrivateRoute element={<ContactList />} />,
      },
      {
        path: '/login',
        element: <Login />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
]);

export default router;
